import { getBase, getHelper } from "lib/api";

const API_URL = getBase("knowledge");

export const loadChart = (session, onSuccess = ()=>{}, onError = ()=>{} ) => {
    const url = `${API_URL}/chart`;

    getHelper(session, url, onSuccess, onError);
}
